var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcInboxMine = function SvgIcInboxMine(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.334 3h7.881c.14 0 .28.013.417.038a.67.67 0 0 1 .808.309c.078.049.155.102.228.16l.108.092 3.603 3.24c.124.112.235.235.33.368a.665.665 0 0 1 .392.884c.022.105.038.212.045.32l.006.163v2.137a.667.667 0 0 1-1.326.098l-.008-.098V8.574c0-.024 0-.048-.002-.073h-3.128a1.5 1.5 0 0 1-1.494-1.356l-.006-.144-.001-2.668H6.334a1 1 0 0 0-.994.884l-.006.117v13.303a1 1 0 0 0 .88.993l.117.007 11.485.03c.515 0 .938-.387.996-.884l.006-.117v-.405a.667.667 0 0 1 1.327-.099l.007.099v.405c0 1.235-.96 2.246-2.174 2.329l-.16.005h-.006l-11.484-.03a2.334 2.334 0 0 1-2.323-2.174L4 18.636V5.335c0-1.235.96-2.246 2.174-2.329L6.334 3h7.881zm8.357 7.17a.42.42 0 0 1 .242.078l5.35 3.821a.417.417 0 0 1 0 .678l-5.35 3.821a.417.417 0 0 1-.66-.339v-2.084H9.252a.417.417 0 0 1-.417-.417v-2.64c0-.23.187-.416.417-.416h5.023v-2.085c0-.23.186-.416.417-.416zm.83-5.006v1.837c0 .074.048.136.114.158l.053.009 2.061-.001-2.228-2.003z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24-10h268v44H-24z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcInboxMine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-inbox-mine.1d6d311986a54c4b912747e3df56659d.svg";